export default __webpack_public_path__ + "static/media/defendant.8dfb18f7.png";